import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_MTA } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-students-mtahistory",
	templateUrl: "./mtahistory.component.html",
	styleUrls: ["./mtahistory.component.css"],
})
export class MTAHistoryComponent {
	constructor(
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private MTAService: DataService_MTA,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.SchoolID = person.SchoolID;
			this.loadMTAHistory();
			// this.onRefresh();
		});

		if (this.SelectedPerson != undefined) {
			this.loadMTAHistory();
		}
	}

	ngOnChanges() {
		if (this.SelectedPerson != undefined) {
			this.loadMTAHistory();
		}
	}

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	user: any;
	SelectedPerson: any;
	SchoolID: any;
	private subscriptionPersonSelect: Subscription;

	ErrorMessage: any = "";

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";
	isProcessing: any = false;
	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedMTACardUsage: any;
	lstMTACardUsage: any = [];

	//Filter lists
	lstMTAFareboxDesc: any = [];
	lstMTADivisionDesc: any = [];
	lstMTARiderTypeDesc: any = [];
	lstMTARouteStationDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "UseDateDesc", header: "Date" },
		{ field: "UseTimeDesc", header: "Time" },
		{ field: "MTAFareboxDesc", header: "Farebox/Gate" },
		{ field: "MTADivisionDesc", header: "Division" },
		{ field: "MTARiderTypeDesc", header: "Rider Type" },
		{ field: "MTARouteStationDesc", header: "Route/Station" },
		{ field: "DailyAttendanceDesc", header: "CAASS Daily Attendance" },
	];

	///////////////

	///////////////////////////////////

	///////////////////////////////////
	// Load Data
	///////////////////////////////////
	loadMTAHistory() {
		this.loading = true;

		try {
			if (this.StartDate.getFullYear() < 1900) {
				this.loading = false;
				return;
			}
			if (this.EndDate.getFullYear() < 1900) {
				this.loading = false;
				return;
			}
		} catch (e) {
			e.toString();

			this.loading = false;
			return;
		}

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.MTAService.GetMTACardUsageInfo(this.SelectedPerson.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstMTACardUsage = response;

				for (var i = 0; i < this.lstMTACardUsage.length; i++) {
					var next = this.lstMTACardUsage[i];

					next.UseDateDesc = moment(new Date(next.UseDate)).format("MM/DD/YYYY");
					next.UseTimeDesc = moment(new Date(next.UseTime)).format("h:mm a");

					next.UseTime = moment(new Date(next.UseTime)).format("HH:mm:ss");
				}

				//Load Data Filter Lists
				this.lstMTAFareboxDesc = Array.from(new Set(this.lstMTACardUsage.map((item: any) => item.MTAFareboxDesc)));
				this.lstMTADivisionDesc = Array.from(new Set(this.lstMTACardUsage.map((item: any) => item.MTADivisionDesc)));
				this.lstMTARiderTypeDesc = Array.from(new Set(this.lstMTACardUsage.map((item: any) => item.MTARiderTypeDesc)));
				this.lstMTARouteStationDesc = Array.from(new Set(this.lstMTACardUsage.map((item: any) => item.MTARouteStationDesc)));

				this.loading = false;
			},
			(error) => {}
		);
	}
	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////

	onRefresh() {
		this.loadMTAHistory();
	}

	//Custom Button Methods
	onPrintInfo() {
		this.errorMessage = "";

		//Error handling

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrintInfo(response);
			}
		});
	}

	FinishPrintInfo(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//
		//Params from filtering:
		//

		var FareBox = "";
		var Division = "";
		var RiderType = "";
		var RouteStation = "";

		var FBFilter = <HTMLInputElement>document.getElementById("MTAFareboxDesc").children[0].children[0].children[0];

		FareBox = FBFilter.value;

		var DFilter = <HTMLElement>document.getElementById("MTADivisionDesc").children[0].children[0].children[0];

		if (DFilter.innerText != "Any") {
			Division = DFilter.innerText;
		}

		var RTFilter = <HTMLElement>document.getElementById("MTARiderTypeDesc").children[0].children[0].children[0];

		if (RTFilter.innerText != "Any") {
			RiderType = RTFilter.innerText;
		}

		var RSFilter = <HTMLElement>document.getElementById("MTARouteStationDesc").children[0].children[0].children[0];

		if (RSFilter.innerText != "Any") {
			RouteStation = RSFilter.innerText;
		}

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: Start Date
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: End Date
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: Farebox
		strParam += "," + FareBox + "|Farebox";

		//Parameter 5: Division
		strParam += "," + Division + "|Division";

		//Parameter 6: Rider Type
		strParam += "," + RiderType + "|RiderType";

		//Parameter 7: Route Station
		strParam += "," + RouteStation + "|RouteStation";

		//Parameter 8: Sort By
		strParam += "," + "UseDate" + "|SortBy";

		//Parameter 8: Sort Direction
		strParam += "," + "Ascending" + "|SortDirection";

		var reportID: any = 404;

		var result = this.reportService.Print(reportID, strParam, this.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	onPrintLetter() {
		this.errorMessage = "";

		//Error handling
		if (this.lstMTACardUsage.length == 0) {
			this.errorMessage = "No Data Available";

			this.isProcessing = false;

			return;
		}

		//Call SP

		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//
		//Params from filtering:
		//
		var RouteStation = "";

		var RSFilter = <HTMLElement>document.getElementById("MTARouteStationDesc").children[0].children[0].children[0];

		if (RSFilter.innerText != "Any") {
			RouteStation = RSFilter.innerText;
		}

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: Start Date
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: End Date
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: Route Station
		// strParam += "," + RouteStation + "|RouteStation";

		var reportID: any = 427;

		//Add file type selector
		var result = this.reportService.Print(reportID, strParam, this.SchoolID, 1);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	///////////////////////////////////

	///////////////////////////////////
	// Events
	///////////////////////////////////
	onStartDateChange(val) {
		this.StartDate = val;

		this.errorMessage = "";

		this.loadMTAHistory();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.errorMessage = "";

		this.loadMTAHistory();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedMTACardUsage = val.data;
	}
	onRowUnselect(val) {
		this.SelectedMTACardUsage = null;
	}
	///////////////////////////////////
}
